import React, { useState } from "react"
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  FormGroup,
  Label,
  Input,
} from "reactstrap"
import { useTranslation } from "react-i18next"
import { signMyContract } from "store/actions/contractsAction"
import { useDispatch } from "react-redux"
import { showAlert } from "store/reducers/alertReducer"
import CustomLabel from "components/Common/CustomLabel"

const RejectContractModal = ({ isOpen, toggle, trigger }) => {
  const [reason, setReason] = useState("")

  const dispatch = useDispatch()
  const { t } = useTranslation()

  const handleReject = () => {
    if (reason === "")
      return dispatch(
        showAlert({ text: t("Reason is required"), type: "error" })
      )

    const formData = new FormData()
    formData.append("status", 0)
    formData.append("reject_reason", reason)

    dispatch(signMyContract(formData))
      .then(action => {
        const { statusCode, success, message } = action?.payload
        if (statusCode === 200 && success) {
          dispatch(showAlert({ text: message, type: "success" }))
          toggle()
          trigger()
        } else {
          dispatch(showAlert({ text: message, type: "error" }))
        }
      })
      .catch(err => {})
  }

  const handleClose = () => {
    setReason("")
    toggle()
  }

  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>{t("Reject Contract")}</ModalHeader>
      <ModalBody>
        <FormGroup>
          <CustomLabel
            isRequired
            htmlFor="reason"
            label={t("Reason for Rejection")}
          />
          <Input
            type="textarea"
            name="reason"
            id="reason"
            value={reason}
            onChange={e => setReason(e.target.value)}
            placeholder={t("Enter your reason here")}
          />
        </FormGroup>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={handleClose}>
          {t("Close")}
        </Button>
        <Button color="danger" onClick={handleReject}>
          {t("Reject")}
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default RejectContractModal
